module.exports = __webpack_public_path__ + "static/media/back.48bd72d5.svg";